var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tablist"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.key,staticClass:"tab",class:{
			active:
				_vm.$route.matched[0].path.split('/').length > 2
					? !tab.link.indexOf(_vm.$route.matched[0].path)
					: tab.link == _vm.$route.path,
		}},[_c('router-link',{attrs:{"to":tab.link}},[_vm._v(" "+_vm._s(tab.title)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }